import type { Fallacy } from "./types";
import { createStory } from "./types";

export const availabilityHeuristic: Fallacy = {
    id: "availability-heuristic",
    name: "Availability Heuristic",
    emoji: "📰",
    category: "Otak yang Menipu Diri",
    description: "Menilai sesuatu lebih mungkin terjadi karena **contohnya mudah diingat**, bukan berdasarkan **data aktual**.",
    tldr: "Baru lihat berita kecelakaan pesawat, langsung takut terbang — padahal statistiknya aman.",
    detail: "Availability Heuristic adalah **jalan pintas mental** di mana kita menilai probabilitas suatu kejadian berdasarkan **seberapa mudah contohnya muncul di kepala kita**, bukan berdasarkan frekuensi aktualnya.\n\nOtak kita berasumsi: \"Kalau gampang diingat, berarti sering terjadi.\" Padahal **yang mudah diingat belum tentu yang paling sering terjadi** — bisa jadi hanya yang paling dramatis atau paling baru.\n\nMedia sosial dan berita 24 jam **memperparah bias ini**. Kejadian langka tapi dramatis mendapat liputan berlebihan, membuat otak kita menganggapnya lebih umum dari kenyataannya.\n\nCara melawan: Selalu cari **data statistik** sebelum membuat kesimpulan. Tanya: \"Apakah gue menilai ini berdasarkan data, atau berdasarkan cerita yang baru gue dengar?\"",
    story: createStory("Availability Heuristic", "📰", {
      hook: {
        title: "Habis baca berita kecelakaan pesawat?",
        body: "Langsung parno naik pesawat kan? Padahal kemarin-kemarin fine-fine aja tuh.",
      },
      convo: {
        claim: "Kemarin baca berita pesawat turbulensi parah, ada yang patah tulang. Aku langsung cancel tiket, **mending naik kereta aja lebih aman**.",
        response: "Statistiknya kereta jauh lebih berbahaya. **Kamu cuma inget yang baru kedengar.**",
      },
      reveal: {
        body: "Otak kamu nganggep sesuatu **lebih sering terjadi** cuma karena contohnya **gampang diingat**. Yang dramatis dan baru kedengeran = otomatis dianggap umum.",
      },
      insight: {
        title: "Media bikin makin parah",
        body: "Berita 24 jam dan sosmed **nge-boost bias ini**. Kejadian langka tapi heboh diliput terus-terusan, otak kamu jadi nganggep itu hal biasa.",
      },
      engagement: {
        title: "Pernah panik gara-gara berita padahal statistiknya aman?",
        body: "Soal pesawat, makanan, atau yang lain? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["hasty-generalization", "appeal-to-emotion", "framing-effect", "survivorship-bias"],
  };
